import { useState } from 'react';
import ButtonComponent from '~/src/components/common/forms/Button/ButtonComponent';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import * as yup from 'yup';
import { useFormik } from 'formik';
import TempApi from '~/src/services/api/TempApi';
import TextInputComponent from '~/src/components/common/forms/TextInput/TextInputComponent';
import { useHistory } from 'react-router-dom';

export default function TempOperations(): JSX.Element {
  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();
  // add formic, yup, validation
  const schema = yup.object().shape({
    orderNumber: yup.number().integer().required(),
  });

  const handleClick2 = async (v, h): Promise<void> => {
    h(true);
    const res = await TempApi.cleanupOrders(v);
    h(false);
  };

  const formik = useFormik({
    initialValues: {
      orderNumber: '',
    },
    validationSchema: schema,
    onSubmit: (values, { setSubmitting }) => {
      return handleClick2(values, setSubmitting);
    },
  });

  return (
    <WhitePad isFluid>
      <TitleComponent title="Temp Operations" 
      titleLeft="Back"
      onLeftHandler={(): void => history.goBack()}
      />
      <ul>
        <li>
          <TextInputComponent
            key="orderNumber"
            name="orderNumber"
            value={formik.values.orderNumber}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            errors={formik.errors}
            touched={formik.touched}
            label="Clean Order Number"
          />
          Cleanup Orders{' '}
          <ButtonComponent onClick={formik.submitForm} title="Cleanup Orders" isSubmitting={loading} />
        </li>
      </ul>
    </WhitePad>
  );
}
